import { get, map, find, toLower, isEmpty, isNil } from 'lodash';
import { Helpers } from '@utils/helpers';

export class CoverageAttribute {
  public sumAssured: number;
  public planPremiumMode: string;
  public nationalityCode: string;
  public residencyCodeLifeAssured?: string;
  public assuredNationalityCode?: string;
  public isLifeAssuredPR?: string;
  public residencyCodeAssured?: string;
  public sourceOfFunds?: string;
  public currency?: string;
  public isAssuredPR?: string;

  /**Optionals */
  public code?: string;
  public riderType?: string;
  public policyTerm?: number | string;
  public premiumTerm?: number;
  public maxProjTerm?: number;
  public sumAssuredMin?: number;
  public sumAssuredMax?: number;
  public modalPremiumMin?: number;
  public modalPremiumMax?: number;
  public paymentFreq?: number;
  public expiryAge?: number;
  public componentCode?: string;
  public mortalityClass?: string;
  public residencyCode?: string;
  public assuredResidencyCode?: string;
  public annualisedPremium?: number;
  public trueAnnualisedPremium?: number;
  public annualPremium?: number;
  public halfYearlyPremium?: number;
  public quarterlyPremium?: number;
  public monthlyPremium?: number;
  public modalPremium?: number;
  public insurancePremium?: number;
  public annualizedPremium?: number;
  public promoCodeSummary?: string;
  public discountEligible?: boolean;
  public firstYrDiscountEligible?: boolean;
  public discountedPremium?: any;
  public promoCode?: string;
  public productCode?: string;

  constructor(initial: any) {
    this.sumAssured = get(initial, 'sumAssured', 0);
    this.planPremiumMode = get(initial, 'planPremiumMode', '');
    this.nationalityCode = get(initial, 'nationalityCode', 'SG');
    this.currency = get(initial, 'currency', 'SGD');

    this.residencyCodeAssured = get(initial, 'residencyCodeAssured', 'SG');
    this.residencyCodeLifeAssured = get(initial, 'residencyCodeLifeAssured', 'SG');
    this.assuredNationalityCode = get(initial, 'assuredNationalityCode', 'SG');
    this.isLifeAssuredPR = get(initial, 'isLifeAssuredPR', 'No');
    this.isAssuredPR = get(initial, 'isAssuredPR', 'No');
    this.sourceOfFunds = get(initial, 'sourceOfFunds', 'Cash');

    Object.assign(this, initial);
  }
}

export class Coverages {
  public id: string;
  public type: string;
  public name?: string;
  public productClass?: string;
  public class?: string;
  public premiumType?: string;
  public mode?: string;
  public productCode?: string;
  public code?: string;
  public riderType?: string;
  public addType?: string;
  public attributes?: CoverageAttribute;
  constructor(initial: any) {
    this.id = get(initial, 'id', 'simpleTermPlan');
    this.type = get(initial, 'type', 'P');
    Object.assign(this, initial);
  }
}
export class LifeProfile {
  public name: string;
  public gender: string;
  public smoker: string;
  public dob: string;
  public age: number;
  public occupationName: string;
  public relationshipName: string;
  public relationshipId: string;
  public type: string;
  public occupationCode?: string;
  public riskClass?: string;
  constructor(initial: any) {
    this.name = get(initial, 'name', '');
    this.gender = get(initial, 'gender', '');
    this.smoker = get(initial, 'smoker', '');
    this.dob = get(initial, 'dob', '');
    this.age = get(initial, 'age', 0);
    this.occupationName = get(initial, 'occupationName', '');
    this.relationshipName = '';
    this.relationshipId = '';
    this.type = 'life-assured';
    if (initial.occupationCode) {
      this.occupationCode = get(initial, 'occupationCode', '');
    }
    if (initial.riskClass) {
      this.riskClass = get(initial, 'riskClass', '');
    }
  }
}

export class SQSPocketRequest {
  public proposalType: string;
  public lifeprofiles: LifeProfile[];
  public isBIStacking: boolean;
  public coverages: Coverages[];
  public document: string[];
  public backdate: string;
  public psqsversion: string;
  public deviceos: string;
  public firmClntnum: string;
  public sourceOfBusiness: string;
  public loginId: string;
  public transactionId: string;

  constructor(initial: any) {
    this.proposalType = get(initial, 'proposalType', 'LA');
    this.lifeprofiles = get(initial, 'lifeprofiles', []);
    this.coverages = get(initial, 'coverages', []);
    this.isBIStacking = get(initial, 'isBIStacking', false);
    this.document = get(initial, 'document', []);
    this.backdate = get(initial, 'backdate', '');
    this.psqsversion = get(initial, 'psqsversion', '');
    this.deviceos = get(initial, 'deviceos', '');
    this.firmClntnum = get(initial, 'firmClntnum', '');
    this.sourceOfBusiness = get(initial, 'sourceOfBusiness', '');
    this.loginId = get(initial, 'loginId', 'QnB');
    this.transactionId = get(initial, 'transactionId','');
  }
}

export class SQSPocketResponse {
  loginId: string;
  firmClntnum: string;
  sourceOfBusiness: string;
  proposalType: string;
  isBIStacking: boolean;
  tables: any;
  errors: any;
  sqsVersion: string;
  infos: any;
  lifeProfiles: LifeProfile[];
  coverages: Coverages[];
  discountEligible?: boolean;
  perpetualDiscountEligible?: boolean;
  firstYearDiscountEligible?: boolean;

  totalPerpetualDiscount?: number;
  totalFirstYearDiscount?: number;
  totalOriginalPremiumAmt?: number;
  totalAftDisOriginalPremiumAmt?: number;
  totalAnnualizedPremium?: number;

  totalOriginalPremium?: any;
  totalAftDisOriginalPremium?: any;

  isCIRider?: boolean;
  isPARider?: boolean;

  public name: string;

  constructor(initial: any) {
    this.loginId = get(initial, 'loginId', '');
    this.firmClntnum = get(initial, 'firmClntnum', '');
    this.sourceOfBusiness = get(initial, 'sourceOfBusiness', '');
    this.proposalType = get(initial, 'proposalType', '');
    this.isBIStacking = get(initial, 'isBIStacking', false);
    this.sqsVersion = get(initial, 'sqsVersion', false);
    this.tables = get(initial, 'tables', []);
    this.errors = get(initial, 'errors', []);
    this.infos = get(initial, 'infos', []);

    this.totalOriginalPremium = get(initial, 'totalOriginalPremium', '-');
    this.totalAftDisOriginalPremium = get(initial, 'totalAfterDiscountPremium', '-');
    this.totalAnnualizedPremium = get(initial, 'totalAnnualizedPremium', '-');

    const profiles = get(initial, 'lifeProfiles', []);
    this.lifeProfiles = map(profiles, p => new LifeProfile(p));

    const coverages = get(initial, 'coverages', []);
    this.coverages = map(coverages, co => {
      const atts = get(co, 'attributes', {});
      const attributes = new CoverageAttribute(atts);
      return new Coverages({ ...co, attributes });
    });
    const simplePlan: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    this.discountEligible = get(simplePlan, 'attributes.discountEligible', false) && Boolean(get(simplePlan, 'attributes.discountedPremium', false));
    this.perpetualDiscountEligible = this.discountEligible && (get(simplePlan, 'attributes.discountedPremium.staffDiscount', 0) > 0);
    this.firstYearDiscountEligible = this.discountEligible && get(simplePlan, 'attributes.firstYrDiscountEligible', false) && Boolean(get(simplePlan, 'attributes.discountedPremium', false)) && (get(simplePlan, 'attributes.discountedPremium.firstYrDiscAmnt', 0) > 0);

    this.totalPerpetualDiscount = get(initial, 'totalPerpetualDiscount', '-');
    this.totalFirstYearDiscount = Number(get(initial, 'totalFirstYearDiscount', '-'));

    this.totalOriginalPremiumAmt = get(initial, 'totalOriginalPremium', '-');
    this.totalAftDisOriginalPremiumAmt = get(initial, 'totalAfterDiscountPremium', '-');

    this.name = get(simplePlan, 'name', '-');

  }

  public get sioQuote() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const simplePlan: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lateStageAddCICover' });
    const personalAccidentPlan: Coverages | undefined = find(coverages, { id: 'personalAccidentRider' });
    const planPremiumMode = get(simplePlan, 'attributes.planPremiumMode', '');
    const premiumFreq = Helpers.getPremiumTermByCode(planPremiumMode);
    if (simplePlan) {
      const simplePlanDetails = this.getPlanDetails(simplePlan);
      listing.push(
        {
          name: 'Basic plan',
          details: [
            { text: 'Basic plan', value: get(simplePlanDetails, 'name', '-') },
            { text: 'Sum assured', value: get(simplePlanDetails, 'sumAssured', '-') },
            { text: 'Premium payment term', value: `Yearly renewable` },
            { text: 'Premium amount', value: get(simplePlanDetails, 'discPremiumAmount', '-') },
          ]
        }

      );
    }

    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push({
        name: 'Add-ons',
        details: [
          { text: 'Rider', value: get(ciPlanDetails, 'name', '-') },
          { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
          { text: 'Premium payment term', value: `Yearly renewable` },
          { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
        ]
      });
    }

    if (personalAccidentPlan) {
      const paPlanDetails = this.getPlanDetails(personalAccidentPlan);
      listing.push({
        details: [
          { text: 'Rider', value: get(paPlanDetails, 'name', '-') },
          { text: 'Sum assured', value: Helpers.toCurrency(get(paPlanDetails, 'sumAssured', '-')) },
          { text: 'Premium payment term', value: `Yearly renewable` },
          { text: 'Premium amount', value: get(paPlanDetails, 'discPremiumAmount', '-') },
        ]
      });
    }

    const promotions = [
      this.firstYearDiscountEligible && '1st year discount',
      this.perpetualDiscountEligible && 'Perpetual discount',
    ]

    listing.push(
      {
        name: 'Other details',
        details: [
          { text: 'Premium payment frequency', value: premiumFreq },
          {
            text: 'Promo code',
            value: get(simplePlan, 'attributes.promoCode', '-'),
            type: 'promotion',
            promotions: promotions.filter(o => !isNil(o) && !isEmpty(o)),
          },
        ]
      }
    )

    return listing;

  }

  public get dpiQuote() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const directTermPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect' });
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect_CIAB' });
    const premiumTerm = get(directTermPlan, 'attributes.premiumTerm', '-');
    const premiumFrequency = Helpers.getPremiumTermByCode(get(directTermPlan, 'attributes.planPremiumMode', '-'));
    if (directTermPlan) {
      const directPlanDetails = this.getPlanDetails(directTermPlan);
      listing.push(
        {
          name: 'Basic plan',
          details: [
            { text: 'Basic plan', value: get(directPlanDetails, 'name', '-') },
            { text: 'Sum assured', value: get(directPlanDetails, 'sumAssured', '-') },
            { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
            { text: 'Premium amount', value: get(directPlanDetails, 'discPremiumAmount', '-') },
          ]
        }

      );
    }

    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push({
        name: 'Add-on(s)',
        details: [
          { text: 'Rider', value: get(ciPlanDetails, 'name', '-') },
          { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
          { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
          { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
        ]
      });
    }

    listing.push(
      {
        name: 'Other details',
        details: [
          { text: 'Premium payment frequency', value: premiumFrequency },
        ]
      }
    )

    return listing;

  }

  public get sioPremium() {
    const coverages = [...this.coverages];
    const coverage: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const premiumTerm = Helpers.getPremiumTermByCode(get(coverage, 'attributes.planPremiumMode', '-'));
    const discountEligible = get(coverage, `attributes.discountEligible`, false)
    const annualPremium = this.totalOriginalPremiumAmt || 0;
    const firsYearDiscountType = get(coverage, `attributes.discountedPremium.firstYrDiscType`, '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(coverage, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    const promotions: any[] = [];
    if (discountEligible) {
      promotions.push(
        this.firstYearDiscountEligible && { text: '1st year discount', value: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType) },
        this.perpetualDiscountEligible && { text: 'Perpetual discount', value: `${this.totalPerpetualDiscount}%` }
      )
    }
    const discountedAnnualPremium = discountEligible ? this.totalAftDisOriginalPremiumAmt || 0 : annualPremium || 0;

    const hasDiscount = this.firstYearDiscountEligible || this.perpetualDiscountEligible;

    return {
      totalAnnualizedPremium: this.totalAnnualizedPremium,
      totalPremium: { text: `premium payable`, value: Helpers.toCurrency(discountedAnnualPremium) },
      details: [
        { text: `${hasDiscount ? 'Premium before discount' : 'Premium payable'}`, value: Helpers.toCurrency(annualPremium), type: 'total', hasDiscount },
        hasDiscount && {
          text: 'Premium payable after discount', value: Helpers.toCurrency(discountedAnnualPremium),
          promotions: promotions.filter(o => o)
        },
      ].filter(o => !isEmpty(o) && !isNil(o)),
      paymentFrequency: { text: 'Payment frequency', value: premiumTerm }
    };
  }

  public get dpiPremium() {
    const coverage = this.coverages[0] || null;
    const premiumTerm = Helpers.getPremiumTermByCode(get(coverage, 'attributes.planPremiumMode', '-'));
    return {
      totalPremium: { text: `premium payable`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0) },
      details: [
        { text: `Premium payable`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0), type: 'total', hasDiscount: false },
      ],
      paymentFrequency: { text: 'Payment frequency', value: premiumTerm }
    };
  }

  public get sioPlanDetails() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const simplePlan: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const planPremiumMode = get(simplePlan, 'attributes.planPremiumMode', '');
    const premiumFreq = Helpers.getPremiumTermByCode(planPremiumMode);
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lateStageAddCICover' });
    const personalAccidentPlan: Coverages | undefined = find(coverages, { id: 'personalAccidentRider' });
    if (simplePlan) {
      const simplePlanDetails = this.getPlanDetails(simplePlan);
      listing.push(
        { text: 'Basic plan', value: get(simplePlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(simplePlanDetails, 'sumAssured', '-') },
        { text: 'Premium payment term', value: `Yearly renewable` },
        { text: 'Premium amount', value: get(simplePlanDetails, 'discPremiumAmount', '-') },
      );
    }

    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push(
        { text: 'Rider', value: get(ciPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
        { text: 'Premium payment term', value: `Yearly renewable` },
        { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
      )
    }

    if (personalAccidentPlan) {
      const paPlanDetails = this.getPlanDetails(personalAccidentPlan);
      listing.push(
        { text: 'Rider', value: get(paPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: Helpers.toCurrency(get(paPlanDetails, 'sumAssured', '-')) },
        { text: 'Premium payment term', value: `Yearly renewable` },
        { text: 'Premium amount', value: get(paPlanDetails, 'discPremiumAmount', '-') },
      )
    }
    const firsYearDiscountType = get(simplePlan, 'attributes.discountedPremium.firstYrDiscType', '');
    let firstYearDiscount = this.totalFirstYearDiscount;
    if (firsYearDiscountType === 'percent' || firsYearDiscountType === 'P') {
      firstYearDiscount = get(simplePlan, 'attributes.discountedPremium.firstYrDisc', 0);
    }
    listing.push(
      { text: 'Premium payment frequency', value: premiumFreq, reviewOnly: true },
      { text: `Total ${toLower(premiumFreq)} premium`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0), reviewOnly: true },
      (this.firstYearDiscountEligible || this.perpetualDiscountEligible) && { text: `Total ${toLower(premiumFreq)} premium payable (after discount applied)`, value: Helpers.toCurrency(this.totalAftDisOriginalPremiumAmt || 0), reviewOnly: true },
      this.firstYearDiscountEligible && { text: '1st year discount', value: this.formatDiscount(firstYearDiscount || 0, firsYearDiscountType), reviewOnly: true },
      this.perpetualDiscountEligible && { text: 'Perpetual discount', value: this.totalPerpetualDiscount + '%', reviewOnly: true },
    )
    return listing.filter(o => !isEmpty(o) && !isNil(o));
  }

  public get dpiPlanDetails() {
    const listing: any[] = [];
    const coverages = [...this.coverages];
    const directTermPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect' });
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect_CIAB' });
    const premiumTerm = get(directTermPlan, 'attributes.premiumTerm', '-');
    const premiumFrequency = Helpers.getPremiumTermByCode(get(directTermPlan, 'attributes.planPremiumMode', '-'));
    const premiumFreq = Helpers.getPremiumTermByCode(get(directTermPlan, 'attributes.planPremiumMode', '-'));

    if (directTermPlan) {
      const directPlanDetails = this.getPlanDetails(directTermPlan);
      listing.push(
        { text: 'Basic plan', value: get(directPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(directPlanDetails, 'sumAssured', '-') },
        { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
        { text: 'Premium amount', value: get(directPlanDetails, 'discPremiumAmount', '-') },
      )
    }
    if (illnessCoverPlan) {
      const ciPlanDetails = this.getPlanDetails(illnessCoverPlan);
      listing.push(
        { text: 'Add-on coverage', value: get(ciPlanDetails, 'name', '-'), fontWeight: 'bold' },
        { text: 'Sum assured', value: get(ciPlanDetails, 'sumAssured', '-') },
        { text: 'Policy term / Premium payment term*', value: `${premiumTerm} years` },
        { text: 'Premium amount', value: get(ciPlanDetails, 'discPremiumAmount', '-') },
      )
    }
    listing.push(
      { text: 'Premium payment frequency', value: premiumFrequency },
      { text: `Total ${toLower(premiumFreq)}  premium`, value: Helpers.toCurrency(this.totalOriginalPremiumAmt || 0) },
      { text: '* Premium payment term is equal to the policy term', value: '', reviewOnly: true }
    )
    return listing;
  }

  public get dpiPremiumTerm(): string {
    const coverages = [...this.coverages];
    const directTermPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect' });
    const premiumTerm = get(directTermPlan, 'attributes.premiumTerm', '-');
    return `${premiumTerm} years`;
  }

  public get sioPlanDetailsSummary() {
    const summaries = this.sioPlanDetails;
    const totalPremium = this.discountEligible ? this.totalAftDisOriginalPremiumAmt : this.totalOriginalPremiumAmt;
    return [
      ...summaries.filter(o => !get(o, 'reviewOnly', false)),
      { text: `Total premium amount`, value: Helpers.toCurrency(totalPremium || 0), fontWeight: 'bold' }
    ]
  }

  public get promoCode() {
    const coverage = this.coverages[0] || null;
    return get(coverage, 'promoCode', '');
  }

  public get sumAssured() {
    const coverage = this.coverages[0] || null;
    return get(coverage, 'attributes.sumAssured', 0);
  }

  public get discounts(): any {
    const list = [];
    const coverage = this.coverages[0] || null;
    const discountEligible = get(coverage, `attributes.discountEligible`, false);
    if (discountEligible) {
      list.push(
        this.perpetualDiscountEligible && `The ${this.totalPerpetualDiscount}% discount is applied annually on policy renewal.`,
        this.firstYearDiscountEligible && `1st year discount is a one-time discount on premiums in the first policy year and does not apply on policy renewal.`
      )
    }
    return list.filter(o => !isEmpty(o));
  }

  public get sioAddon(): { name: string, price: string }[] {
    let list: { name: string, price: string }[] = [];
    const coverages = [...this.coverages];
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lateStageAddCICover' });
    const personalAccidentPlan: Coverages | undefined = find(coverages, { id: 'personalAccidentRider' });
    if (illnessCoverPlan) {
      list.push({ name: illnessCoverPlan.name || '', price: `${illnessCoverPlan.attributes?.sumAssured || 0}` })
    }
    if (personalAccidentPlan) {
      list.push({ name: personalAccidentPlan.name || '', price: `${personalAccidentPlan.attributes?.sumAssured || 0}` })
    }
    return list;
  }

  
  public get dpiAddon(): { name: string, price: string }[] {
    let list: { name: string, price: string }[] = [];
    const coverages = [...this.coverages];
    const illnessCoverPlan: Coverages | undefined = find(coverages, { id: 'lifeDirect_CIAB' });
    if (illnessCoverPlan) {
      list.push({ name: illnessCoverPlan.name || '', price: `${illnessCoverPlan.attributes?.sumAssured || 0}` })
    }
    return list;
  } 

  public checkValidPromoCode(inputCode: string): { valid: boolean, error: string } {
    const coverages = [...this.coverages];
    const simplePlan: Coverages | undefined = find(coverages, { id: 'simpleTermPlan' });
    const discountEligible = simplePlan?.attributes?.discountEligible;
    const promoCode = get(simplePlan, 'attributes.promoCode', '');
    if (inputCode === promoCode && discountEligible) {
      return { valid: true, error: '' };
    }
    // return { valid: true, error: '' }; //use for local check bypass
    return {
      valid: false,
      error: 'Promo code is invalid'
    };
  }

  private formatDiscount(value: number, type: string): string {
    if (type === 'dollar') {
      return Helpers.toCurrency(value);
    }
    if (type === 'percent' || type === 'P') {
      return `${value}%`
    }
    return `${Helpers.toCurrency(value)}`;
  }


  /**Cleaning code */

  private getPlanDetails(plan: Coverages): any {
    if (isNil(plan) || isEmpty(plan)) {
      return null;
    }

    const premiumAmount = get(plan, `attributes.modalPremium`, '-');
    let finalPremiumAmount = premiumAmount;
    const name = get(plan, 'name', '-');
    const sumAssured = get(plan, 'attributes.sumAssured');

    const isDiscountEligible = get(plan, 'attributes.discountEligible', false);
    const isFirstYearDiscount = get(plan, 'attributes.firstYrDiscountEligible', false);

    const hasFirstYrDiscount = isDiscountEligible &&
      isFirstYearDiscount &&
      get(plan, 'attributes.discountedPremium.firstYrDiscAmnt', 0) > 0

    const hasPerpectualDiscount = isDiscountEligible &&
      get(plan, 'attributes.discountedPremium.staffDiscount', 0) > 0


    if (hasFirstYrDiscount) {
      finalPremiumAmount = get(plan, `attributes.discountedPremium.firstYrModalPremium`, '-')
    } else {
      if (hasPerpectualDiscount) {
        finalPremiumAmount = get(plan, `attributes.discountedPremium.modalPremium`, '-')
      }
    }

    return {
      name,
      sumAssured: Helpers.toCurrency(sumAssured || 0),
      premiumAmount: Helpers.toCurrency(premiumAmount),
      discPremiumAmount: Helpers.toCurrency(finalPremiumAmount),
    }

  }
}